import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DictOption {
  value: string;
  label: string;
}

export interface DictProdutoOculto extends DictOption {
  /** conta contabil pai - usado para filtrar a cascata no front */
  conta: string;
}

export interface DictsOculto {
  contas:       DictOption[];
  bus:          DictOption[];
  centrosCusto: DictOption[];
  produtos:     DictProdutoOculto[];
}

interface DictsResponse { success: boolean; data: DictsOculto; }

/**
 * Listas usadas no fluxo de fornecedor oculto: Conta Contabil, BU,
 * Centro de Custo e Produto (cascata por Conta).
 *
 * Cache em memoria: o backend monta a lista a partir de enums hardcoded
 * (eGlAccount/eBu/eProduct) + um SELECT na CTT, entao nao precisa de
 * round-trip a cada abertura de tela.
 */
@Injectable({ providedIn: 'root' })
export class DictsOcultoService {
  private cache$: Observable<DictsOculto> | null = null;

  constructor(private http: HttpClient) {}

  load(): Observable<DictsOculto> {
    if (this.cache$) { return this.cache$; }
    this.cache$ = this.http.get<DictsResponse>('portalnf/dicts/oculto').pipe(
      map(r => r.data ?? { contas: [], bus: [], centrosCusto: [], produtos: [] }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    return this.cache$;
  }

  /** Filtra produtos pela conta selecionada (cascata) */
  produtosPorConta(produtos: DictProdutoOculto[], conta: string): DictOption[] {
    if (!conta) { return []; }
    return produtos
      .filter(p => p.conta === conta)
      .map(p => ({ value: p.value, label: p.label }));
  }
}
